import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as AplhaList from '../../../../data/alphabet.json';

@Component({
  selector: 'ngx-alphabet-filter',
  templateUrl: './alphabet-filter.component.html',
  styleUrls: ['./alphabet-filter.component.scss']
})
export class AlphabetFilterComponent implements OnInit {

  
  @Input() searchAlpha;
  @Input() existingAlphaLetter;

  alphabetList: any = ( AplhaList as any).default;
  @Output() dataEvent: EventEmitter<any> = new EventEmitter<any>();

 
  constructor() { }

  ngOnInit(): void {
  }


  alphaFilter(data){
    this.searchAlpha=data.value;  
    this.dataEvent.emit(data)
  }

  filterAlpha(existingAlphaLetter: any) {
      // if(this.existingAlphaLetter)
     console.log("existingAlphaLetter - ",existingAlphaLetter, )
     if(existingAlphaLetter?.length>0){
      this.alphabetList=this.alphabetList.map(element => {
          var res= existingAlphaLetter.find(x=>{return element.value?.toString()?.toLowerCase()==x?.toString()?.toLowerCase()})
           if(!!res)
            element.display=true
           else 
            element.display=false
          return element
      }); 
    }
  }
}
